import {
  vArray,
  vCheck,
  vMinLength,
  vNonEmptyString,
  vObject,
  type vOutput,
  vPipe,
  vString,
  vTransform,
} from '../validation/index.ts'

export interface OAuthApp {
  _id: string
  clientId: string
  clientSecret: string
  clientName: string
  redirectUris: string[]
  createdDate: Date
}

export type OAuthAppListDto = Omit<OAuthApp, 'clientSecret'>

const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]'])

const isValidRedirectUri = (uri: string): boolean => {
  let parsed: URL
  try {
    parsed = new URL(uri)
  } catch {
    return false
  }

  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    return false
  }

  if (parsed.protocol === 'http:' && !LOOPBACK_HOSTS.has(parsed.hostname)) {
    return false
  }

  return true
}

export const oauthAppUpsertSchema = vObject({
  clientName: vNonEmptyString(),
  redirectUris: vPipe(
    vArray(vString()),
    vMinLength(1),
    vTransform(values => Array.from(new Set(values.filter(v => !!v?.trim())))),
    vCheck(
      values => values.every(uri => isValidRedirectUri(uri)),
      'Each redirect URI must be a valid http(s) URL, use https except localhost loopback, and cannot contain credentials or fragments',
    ),
  ),
})
export type OAuthAppUpsertDto = vOutput<typeof oauthAppUpsertSchema>

export interface OAuthAppCreateResult {
  clientId: string
  clientSecret: string
  created: Date
}
